module.exports = __webpack_public_path__ + "files/05c0c7a1ce94f8a98aeecd693702df4d.png";